angular.module('autoremind.queries', [])
    .controller('autoremind.queries.ScreenController', 
// Setup dependencies
['$scope', '$location', '$http', 'logger', 'adminQueryService', 'dialogs',
    function ($scope, $location, $http, logger, adminQueryService, dialogs) {
        $scope.fetchState = {
            "buttonLabel": "Reload queries",
            "busy": false
        };
        $scope.fetchStateQuery = {
            "buttonLabel": "Query",
            "busy": false
        };
        $scope.filterCondition = false;
        $scope.inputValues = [];
        $scope.output = [];
        $scope.selectedQuery = null;
        $scope.selectedFilter = undefined;
        $scope.filterKey = undefined;
        $scope.filterQuery = undefined;
        /**
         *
         */
        $scope.selectQuery = function () {
            // Clear input fields
            $scope.inputValues = [];
        };
        $scope.onFilterChange = function (event) {
            $scope.selectedFilter = event.trim();
        };
        /**
         *
         */
        $scope.getQueries = function () {
            $scope.fetchState.busy = true;
            $scope.fetchState.buttonLabel = 'Loading...';
            $scope.inputValues = [];
            adminQueryService.getQueries()
                .then(function (response) {
                logger.debug('result:' + response);
                $scope.queries = response.queries;
                $scope.selectedQuery = $scope.queries[0];
                //$scope.filterCondition.operator = $scope.queries[0].queryname;
                $scope.fetchState.busy = false;
                $scope.fetchState.buttonLabel = 'Reload queries';
                //$scope.search.queryname= $scope.queries[0].queryname;
            });
        };
        $scope.doQuery = function () {
            $scope.output = [];
            for (var j = 0; j < $scope.selectedQuery.parameters.length; j++) {
                $scope.output.push({
                    name: $scope.selectedQuery.parameters[j].name,
                    value: $scope.inputValues[j],
                });
            }
            ;
            $scope.fetchStateQuery.busy = true;
            $scope.fetchStateQuery.buttonLabel = 'Loading...';
            $scope.result = null;
            adminQueryService.executeQuery($scope.selectedQuery.queryname, $scope.output)
                .then(function (response) {
                logger.debug('result:' + response);
                $scope.result = response;
                $scope.fetchStateQuery.busy = false;
                $scope.fetchStateQuery.buttonLabel = 'Execute Query';
                if ($scope.selectedQuery.queryname === 'AR3RemindersAccounts') {
                    $scope.filterCondition = true;
                    $scope.filterKey = 'userStatus';
                    $scope.filterQuery = 'AR3RemindersAccounts';
                    var filter = [];
                    $scope.selectedQuery.filter = [];
                    if (response.rows.length > 0) {
                        filter.push({ displayname: 'all', value: 'all' });
                        Object.values(response.rows).map(rows => {
                            if (filter.findIndex(val => val.displayname === rows.userStatus) === -1) {
                                filter.push({ displayname: rows.userStatus.trim(), value: rows.userStatus.trim() });
                            }
                        });
                    }
                    $scope.selectedQuery.filter = filter;
                    $scope.selectedFilter = $scope.selectedQuery.filter[0].value;
                }
            }, function (data) {
                $scope.fetchStateQuery.busy = false;
                $scope.fetchStateQuery.buttonLabel = 'Execute Query';
                dialogs.error('Error', 'ERROR: ' + data.status);
            });
        };
        $scope.selectedRow = null;
        /**
         *
         */
        $scope.selectRow = function (row, index) {
            $scope.selectedRow = row;
        };
        $scope.filteredRow = function (row) {
            if ($scope.filterCondition) {
                if (row.userStatus !== $scope.selectedFilter && $scope.selectedFilter !== 'all') {
                    return false;
                }
            }
            return true;
        };
        $scope.filteredRowCount = function (rows) {
            var count = 0;
            if ($scope.filterCondition && $scope.selectedFilter !== 'all') {
                Object.values(rows).map(row => {
                    if (row.userStatus === $scope.selectedFilter) {
                        count++;
                    }
                });
            }
            return count;
        };
    }]);
//# sourceMappingURL=queries.controllers.js.map